$(document).ready(function () {
  //Single product slider
  var swiperProductGallery = new Swiper(".pdp-main-slider", {
    slidesPerView: 1,
    loop: true,
    center: false,
    spaceBetween: 16,
    centeredSlides: false,
    freeMode: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });


  $(".select-variant-gallery").on("click", function () {
    let variant_id = $(this).data("variant-id");
    let variant_swiper_index = $("#variant_image_" + variant_id).data(
      "swiper-slide-index"
    );

    if (typeof variant_swiper_index !== "undefined") {
      swiperProductGallery.slideToLoop(variant_swiper_index, 200);
    }
  });

  // fixed buttons on scroll
  var elementPosition = $("#fixed").offset();

  $(window).scroll(function () {
    if ($(window).scrollTop() > elementPosition.top) {
      $("#fixed").addClass("fixed-div-active");
    } else {
      $("#fixed").removeClass("fixed-div-active");
    }
  });

  function MobileOnlySlider() {
    let featuredSwiper;
    const sliderBreakpoint = window.matchMedia("(min-width:1025px)");
    const sliderBreakpointChecker = function () {
      if (sliderBreakpoint.matches === true) {
        $(".featured-slider > div")
          .removeClass("swiper-wrapper")
          .addClass("row");
        $(".featured-slider .row > div").removeClass("swiper-slide");

        if (featuredSwiper !== undefined) featuredSwiper.destroy(true, true);
      } else if (sliderBreakpoint.matches === false) {
        $(".featured-slider > div")
          .removeClass("row")
          .addClass("swiper-wrapper");
        $(".featured-slider .swiper-wrapper > div").addClass("swiper-slide");
        featuredSwiper = new Swiper(".featured-slider", {
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          breakpoints: {
            320: {
              slidesPerView: 1.4,
            },
            768: {
              slidesPerView: 2.1,
            },
            1024: {
              slidesPerView: 3.1,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }
    };

    sliderBreakpoint.addListener(sliderBreakpointChecker);
    sliderBreakpointChecker();
  }

  MobileOnlySlider();

  $(".pdp-main-accordion-item").on("click", ".title-wrapper", function () {
    $(this).parent().siblings().removeClass("pdp-main-accordion-item-active");
    $(this).parent().toggleClass("pdp-main-accordion-item-active");
  });
});
